import { setSpecificMessage, ipv6 } from "valibot";
setSpecificMessage(
  ipv6,
  (issue) => `IPv6 invalide: reçu ${issue.received}`,
  "fr"
);